<template>
  <div class="login-page">
    <div class="login-shell">
      <section class="brand-side">
        <div class="brand-mark">
          <el-image :src="require('@/assets/image/hyzlin-logo.png')" class="brand-logo" fit="contain"></el-image>
        </div>
        <p class="brand-eyebrow">HIZLIN TRAINING CENTER</p>
        <h1>海之林在线考试系统</h1>
        <p class="brand-intro">面向企业培训、阶段考核与成绩管理的内部考试平台</p>
        <div class="brand-tags">
          <span>在线答题</span>
          <span>考试发布</span>
          <span>成绩批改</span>
        </div>
      </section>

      <section class="form-side">
        <div class="form-heading">
          <p>{{ show_login ? 'ACCOUNT LOGIN' : 'STUDENT REGISTER' }}</p>
          <h2>{{ show_login ? '账号登录' : '学生注册' }}</h2>
          <span>{{ show_login ? '请输入账号信息进入系统' : '填写信息后等待老师激活账号' }}</span>
        </div>

        <el-form v-if="show_login" :model="loginForm" :rules="rules" ref="loginForm" label-width="0" class="auth-form">
          <el-form-item label="" prop="username">
            <el-input v-model="loginForm.username" prefix-icon="el-icon-user-solid" placeholder="请输入用户名"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <div @keyup.enter="Login">
              <el-input v-model="loginForm.password" type="password" placeholder="请输入密码"
                        prefix-icon="el-icon-lock" clearable></el-input>
            </div>
          </el-form-item>
          <el-form-item class="button-row">
            <el-button type="primary" @click="Login" class="primary-action">登录</el-button>
            <el-button class="secondary-action" @click="show_login=false">学生注册</el-button>
          </el-form-item>
        </el-form>

        <el-form v-if="!show_login" :model="registerForm" :rules="rules" ref="loginForm" label-width="0" class="auth-form">
          <el-form-item label="" prop="username">
            <el-input v-model="registerForm.username" prefix-icon="el-icon-user-solid" placeholder="请输入真实姓名"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <div>
              <el-input v-model="registerForm.password" type="password" placeholder="请输入您的密码"
                        prefix-icon="el-icon-lock" clearable></el-input>
            </div>
          </el-form-item>
          <el-form-item label="" prop="confirm_password">
            <div>
              <el-input v-model="registerForm.confirm_password" type="password" placeholder="请再次确认密码"
                        prefix-icon="el-icon-lock" clearable></el-input>
            </div>
          </el-form-item>
          <el-form-item label="" prop="class_id">
            <el-select v-model="registerForm.student_class" placeholder="请选择公司" class="company-select">
              <el-option
                  v-for="item in class_option"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="button-row">
            <el-button type="primary" @click="register" class="primary-action">注册</el-button>
            <el-button class="secondary-action" @click="show_login=true">前往登录</el-button>
          </el-form-item>
        </el-form>
      </section>
    </div>
  </div>
</template>

<script>
import {normalizePageData} from '@/utils/pageData'

export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
      },
      registerForm: {
        username: '',
        password: '',
        confirm_password: '',
        student_class: '',
      },
      show_login: true,
      rules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ],
        confirm_password: [
          {required: true, message: '请确认密码', trigger: 'blur'}
        ],
      },
      class_option: [],
    };
  },
  created() {
    this.get_class_list()
  },
  methods: {
    register() {
      let username = this.registerForm.username
      let password = this.registerForm.password
      let confirm_password = this.registerForm.confirm_password
      if (password !== confirm_password) {
        this.$message({
          type: 'error',
          message: '两次密码不一致,请重新输入',
          duration: 3000,
        })
        return false
      }
      let student_class = this.registerForm.student_class
      if (!username || !password || !student_class || !confirm_password) {
        this.$message({
          type: 'error',
          message: '请将注册信息填写完整',
          duration: 2000,
        })
      } else {
        this.$axios({
          method: 'post',
          url: this.$settings.BASE_URL + '/user/userinfo/student_register/',
          data: this.registerForm,
        }).then(res => {
          if (res.data.code === 20000) {
            this.$message({
              type: 'success',
              message: '注册成功,请等待老师激活账号即可登录',
              duration: 4000,
            })
            this.registerForm = {}
          } else {
            this.$message({
              type: 'error',
              message: '用户名已存在,请重新注册',
              duration: 4000,
            })
          }
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '服务器异常',
            duration: 3000,
          })
        })
      }
    },
    get_class_list() {
      this.$axios({
        method: 'get',
        url: this.$settings.BASE_URL + '/user/student_class/',
      }).then(res => {
        this.class_option = normalizePageData(res.data).rows
      })
    },
    Login() {
      if (!this.loginForm.password || !this.loginForm.username) {
        this.$message({
          type: 'error',
          message: '用户名或密码不能为空',
          duration: 3000,
        })
      } else {
        this.$http.post(this.$settings.BASE_URL + '/user/userinfo/login/', this.loginForm).then(res => {
          if (res.data.code === 20000) {
            this.$store.commit('SET_TOKEN', res.data)
            if (res.data.role === 1 || res.data.role === 2) {
              this.$router.push("/TeacherIndex")
            } else if (res.data.role === 0) {
              this.$router.push("/StudentIndex")
            }
          } else {
            this.$message({
              type: 'warning',
              message: res.data.msg,
              duration: 3000,
            })
          }
        }).catch(error => {
          this.$message({
            type: 'error',
            message: '服务器异常',
            duration: 3000,
          })
        })
      }
    },
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 46px 24px;
  box-sizing: border-box;
  color: #11375f;
  font-family: "HarmonyOS Sans SC", "Source Han Sans SC", "PingFang SC", sans-serif;
  background:
      radial-gradient(circle at 12% 18%, rgba(52, 132, 200, 0.20), transparent 28%),
      radial-gradient(circle at 84% 82%, rgba(0, 98, 160, 0.18), transparent 30%),
      linear-gradient(135deg, #edf6fb 0%, #d8ecf6 46%, #c8e4f1 100%);
  overflow: hidden;
  position: relative;
}

.login-page::before,
.login-page::after {
  content: "";
  position: absolute;
  border-radius: 999px;
  pointer-events: none;
}

.login-page::before {
  width: 460px;
  height: 460px;
  left: -160px;
  bottom: -210px;
  background: rgba(255, 255, 255, 0.55);
}

.login-page::after {
  width: 320px;
  height: 320px;
  top: -130px;
  right: -80px;
  border: 42px solid rgba(255, 255, 255, 0.32);
}

.login-shell {
  width: min(1040px, 100%);
  min-height: 560px;
  display: grid;
  grid-template-columns: 1.08fr 0.92fr;
  position: relative;
  z-index: 1;
  overflow: hidden;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.86);
  border: 1px solid rgba(255, 255, 255, 0.82);
  box-shadow: 0 28px 80px rgba(28, 93, 141, 0.24);
  backdrop-filter: blur(10px);
}

.brand-side {
  position: relative;
  padding: 58px 58px 48px;
  color: #fff;
  background:
      linear-gradient(145deg, rgba(9, 78, 142, 0.94), rgba(28, 124, 191, 0.88)),
      url("data:image/svg+xml,%3Csvg width='180' height='180' viewBox='0 0 180 180' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' stroke='rgba(255,255,255,0.18)' stroke-width='1'%3E%3Cpath d='M15 90h150M90 15v150M30 30l120 120M150 30L30 150'/%3E%3Ccircle cx='90' cy='90' r='54'/%3E%3C/g%3E%3C/svg%3E");
}

.brand-side::after {
  content: "";
  position: absolute;
  width: 260px;
  height: 260px;
  right: -82px;
  bottom: -74px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.13);
}

.brand-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 210px;
  padding: 16px 18px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 18px 42px rgba(1, 42, 88, 0.22);
}

.brand-logo {
  width: 190px;
  height: 76px;
}

.brand-eyebrow {
  margin: 78px 0 14px;
  color: rgba(255, 255, 255, 0.76);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.18em;
}

.brand-side h1 {
  margin: 0;
  max-width: 430px;
  font-size: 42px;
  line-height: 1.18;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.brand-intro {
  margin: 18px 0 0;
  max-width: 420px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 17px;
  line-height: 1.8;
}

.brand-tags {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 48px;
}

.brand-tags span {
  padding: 9px 14px;
  border-radius: 999px;
  color: rgba(255, 255, 255, 0.92);
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.18);
  font-size: 14px;
}

.form-side {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 56px 54px;
  background: rgba(255, 255, 255, 0.96);
}

.form-heading {
  margin-bottom: 32px;
}

.form-heading p {
  margin: 0 0 10px;
  color: #2f8bc4;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.18em;
}

.form-heading h2 {
  margin: 0;
  color: #123b63;
  font-size: 30px;
  font-weight: 800;
}

.form-heading span {
  display: block;
  margin-top: 10px;
  color: #7890a2;
  font-size: 14px;
}

.auth-form {
  width: 100%;
}

.auth-form >>> .el-input__inner {
  height: 48px;
  border-radius: 12px;
  border-color: #dbe7ef;
  color: #173a58;
  background: #f8fbfd;
}

.auth-form >>> .el-input__inner:focus {
  border-color: #1f85c7;
  box-shadow: 0 0 0 3px rgba(31, 133, 199, 0.12);
  background: #fff;
}

.auth-form >>> .el-input__prefix {
  color: #7d9db5;
}

.button-row >>> .el-form-item__content {
  display: flex;
  gap: 14px;
}

.primary-action,
.secondary-action {
  width: 50%;
  height: 46px;
  border-radius: 12px;
  font-weight: 700;
}

.primary-action {
  border: 0;
  background: linear-gradient(135deg, #1878bd, #2aa5dc);
  box-shadow: 0 14px 26px rgba(31, 133, 199, 0.25);
}

.secondary-action {
  margin-left: 0 !important;
  color: #176ea8;
  border-color: #cfe4f1;
  background: #eef7fb;
}

.company-select {
  width: 100%;
}

.company-select >>> .el-input__inner {
  height: 48px;
  border-radius: 12px;
}

@media (max-width: 900px) {
  .login-page {
    min-height: 100%;
    height: auto;
    padding: 24px 16px;
    overflow: auto;
  }

  .login-shell {
    grid-template-columns: 1fr;
    min-height: auto;
  }

  .brand-side {
    padding: 34px 28px 30px;
  }

  .brand-eyebrow {
    margin-top: 30px;
  }

  .brand-side h1 {
    font-size: 30px;
  }

  .brand-intro {
    font-size: 15px;
  }

  .brand-tags {
    margin-top: 28px;
  }

  .form-side {
    padding: 34px 26px 28px;
  }

  .button-row >>> .el-form-item__content {
    flex-direction: column;
  }

  .primary-action,
  .secondary-action {
    width: 100%;
  }
}
</style>
